import { RefObject, useEffect, useRef, useState } from 'react';

export const useScrollTop = (): [RefObject<HTMLDivElement>, boolean] => {
  const ref = useRef<HTMLDivElement>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const onChange = () => {
    if (ref.current) {
      const pos = ref.current.scrollTop;

      setIsScrolled(pos !== 0);
    }
  };

  useEffect(() => {
    const $dom = ref.current;

    $dom?.addEventListener('scroll', onChange);

    return () => {
      $dom?.removeEventListener('scroll', onChange);
    };
  });

  return [ref, isScrolled];
};
